import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfUseEnComponent } from './terms-of-use-en.component';
import { TermsOfUseSkComponent } from './terms-of-use-sk.component';
import { TermsOfUseCzComponent } from './terms-of-use-cz.component';

@Component({
  selector: 'app-terms-of-use',
  standalone: true,
  imports: [CommonModule, TermsOfUseEnComponent, TermsOfUseSkComponent, TermsOfUseCzComponent],
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
})
export class TermsOfUseComponent {
  @Input() currentLang = 'en';

  // Shared configuration for all language versions
  effectiveDate = '01.09.2025';
  version = '1.0';
  supportEmail = 'legal@sameta.sk';
  websiteUrl = 'https://app.peopleflow.sk/';
  termsUrl = 'https://app.peopleflow.sk/terms-of-service';
  rssFeedUrl = 'https://app.peopleflow.sk/subprocessors-rss';
}
